module.exports = __webpack_public_path__ + "static/media/SAS Chat Tone 2.d786041a.wav";